module.exports = __webpack_public_path__ + "4.91d8127d.png";